export class LogMessages {
    public static NO_ACCESS = 'User does not have permissions to this resource.';
}